import request from "@/utils/request";
// 获取微信小程序支付的短连接
export function getWeChatAppletShortUrl(data) {
  return request({
    url: '/api-order-receipt/order/getWeChatAppletShortUrl',
    method: 'post',
    data: data
  })
}
// 支付宝支付：
export async function sys_ali_login(data) {
  return request({
    url: `/api-order-receipt/order/sys_ali_login`,
    method: 'get',
    params: data
  })
}
// 查询订单状态
export function queryUUID(data) {
  return request({
    url: `/api-order-receipt/order/queryUUID`,
    method: 'post',
    data: data
  })
}
